module.exports = __webpack_public_path__ + "static/media/four-people-squatting.ef8521c9.svg";